import React from 'react';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton
} from "react-accessible-accordion";
import { FormattedMessage } from '../../util/reactIntl';

import css from './FaqPage.module.css';

const FaqPageContent = (props) => {

  const { currentTab } = props

  const supportLink = <a href="mailto:info@evenitfy.lv" rel="noopener noreferrer">info@evenitfy.lv</a>;

  if (currentTab === 'generalQuestions') {

    // General questions FAQ
    return (
      <Accordion preExpanded={[1]} key="generalQuestionsFAQ" allowZeroExpanded >
        <AccordionItem uuid={1}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.generalQuestion1" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.generalAnswer1" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={2}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.generalQuestion2" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.generalAnswer2" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={3}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.generalQuestion3" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.generalAnswer3" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={4}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.generalQuestion4" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.generalAnswer4" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={5}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.generalQuestion5" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.generalAnswer5" values={{ supportLink }} />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    )
  } else if (currentTab === 'providers') {

    // Providers FAQ
    return (
      <Accordion preExpanded={[1]} key="providersFAQ" allowZeroExpanded >
        <AccordionItem uuid={1}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.providersQuestion1" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.providersAnswer1" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={2}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.providersQuestion2" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.providersAnswer2" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={3}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.providersQuestion3" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.providersAnswer3" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={4}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.providersQuestion4" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.providersAnswer4" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={5}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.providersQuestion5" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.providersAnswer5" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={6}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.providersQuestion6" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.providersAnswer6" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={7}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.providersQuestion7" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.providersAnswer7" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    )
  } else {

    // Users FAQ
    return (
      <Accordion preExpanded={[1]} key="usersFAQ" allowZeroExpanded >
        <AccordionItem uuid={1}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.usersQuestion1" />

            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.usersAnswer1" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={2}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.usersQuestion2" />

            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.usersAnswer2" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={3}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.usersQuestion3" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.usersAnswer3" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={4}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.usersQuestion4" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.usersAnswer4" values={{ supportLink }} />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={5}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.usersQuestion5" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.usersAnswer5" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={6}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <FormattedMessage id="FaqPage.usersQuestion6" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              <FormattedMessage id="FaqPage.usersAnswer6" />
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    )
  }
};

export default FaqPageContent;
